// List view (table). Alternative to TaskCard kanban view; user picks via
// the kanban/list toggle on /my-tasks.

import { useMemo } from 'react';
import { Prio, StatusPill, CatTag } from './atoms.jsx';
import { fmtShort, fmtDateTime, isOverdue } from '../lib/dates.ts';

export const ListView = ({ tasks, filter, setFilter, openTask, showAssignee, staff = [] }) => {
  const filters = ['全部', '待开始', '进行中', '阻塞', '已完成', '逾期'];
  const filtered = useMemo(() => tasks.filter(t => {
    if (filter === '全部') return true;
    if (filter === '逾期') return isOverdue(t);
    return t.status === filter;
  }), [tasks, filter]);

  return (
    <div className="vava-card" style={{ padding: 0 }}>
      <div style={{ padding: 16, borderBottom: '1px solid var(--vava-border-soft)' }}>
        <div className="filter-bar">
          {filters.map(f => (
            <button key={f} className={`chip ${filter === f ? 'active' : ''}`} onClick={() => setFilter(f)}>
              {f} · {f === '全部' ? tasks.length : f === '逾期' ? tasks.filter(isOverdue).length : tasks.filter(t => t.status === f).length}
            </button>
          ))}
        </div>
      </div>
      {filtered.length === 0 ? (
        <div className="empty-state">
          <div className="emoji">🍰</div>
          <div className="title">没有待办</div>
          <div className="sub">换个筛选看看</div>
        </div>
      ) : (
        <table className="vava-table">
          <thead>
            <tr>
              <th style={{ width: 50 }}>优先级</th>
              <th>待办</th>
              <th style={{ width: 100 }}>分类</th>
              {showAssignee && <th style={{ width: 100 }}>负责人</th>}
              <th style={{ width: 110 }}>截止日期</th>
              <th style={{ width: 100 }}>状态</th>
              <th style={{ width: 100 }}>最近更新</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map(t => {
              const overdue = isOverdue(t);
              const lastUpdate = t.updates && t.updates[t.updates.length - 1];
              const assignee = staff.find(s => s.id === t.assigneeId);
              return (
                <tr key={t.id} onClick={() => openTask(t.id)}>
                  <td><Prio value={t.priority} /></td>
                  <td>
                    <div style={{ fontWeight: 500 }}>{t.title}</div>
                  </td>
                  <td><CatTag value={t.category} /></td>
                  {showAssignee && <td>{assignee?.name}</td>}
                  <td className="mono" style={{ color: overdue ? 'var(--vava-red)' : 'inherit', fontWeight: overdue ? 600 : 400 }}>
                    {fmtShort(t.dueDate) || '—'}
                    {overdue && <span style={{ fontSize: 11, marginLeft: 4 }}>逾期</span>}
                  </td>
                  <td><StatusPill value={t.status} /></td>
                  <td className="mono" style={{ color: 'var(--vava-text-muted)', fontSize: 12 }}>
                    {lastUpdate ? fmtDateTime(lastUpdate.at).slice(0, 5) : '—'}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
};
